export function tabbedPage() {

    $('#sidebar-tabs').on('click', 'li', function () {
        $('#sidebar-tabs li').removeClass('active');
        $(this).toggleClass('active');
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#" + $(this).attr('data-id')).offset().top - 195
        }, 1000);
    });
    
    $('#scroll-top').on('click', function () {
        var width_window = $(window).width(); ;
        var top = 0;
        if(width_window > 1366){
            top = 95;
        }
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#section-tabbed-page').offset().top - top
        }, 1000);
    });

    $(window).on("scroll", function () {
        var show = $('#scroll-top').hasClass('show');
        if(Math.max(document.body.scrollTop,document.documentElement.scrollTop) > $(window).height()) {
            if(!show)
                $('#scroll-top').addClass('show');
        } else {
            if(show)
                $('#scroll-top').removeClass('show');
        }
    });

    if(screen.width < 1200) {
        var i, n;
        var accordion = document.getElementsByClassName("with-accordion");
        for (i = 0; i < accordion.length; i++) {
            accordion[i].addEventListener("click", function () {


                document.querySelectorAll(".with-accordion").forEach(function (item, i, arr) {
                        item.classList.remove('active');
                    }
                );

                this.classList.add('active');
            });
        }

    }else{

        $(".menu-item-has-children").hover(
            function() {
                $(this).find('.dropdown-menu').addClass('show');
            }, function() {
                $(this).find('.dropdown-menu').removeClass('show');
            }
        );

    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabbedPage.js